var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0533 18.0667C23.4933 18.6133 23.1733 19.4 23.2533 20.24C23.3733 21.68 24.6933 22.7333 26.1333 22.7333H28.6666V24.32C28.6666 27.08 26.4133 29.3333 23.6533 29.3333H8.34659C5.58659 29.3333 3.33325 27.08 3.33325 24.32V15.3467C3.33325 12.5867 5.58659 10.3333 8.34659 10.3333H23.6533C26.4133 10.3333 28.6666 12.5867 28.6666 15.3467V17.2667H25.9732C25.2266 17.2667 24.5466 17.56 24.0533 18.0667Z",
    fill: "#42444D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M19.7999 5.26668V10.3333H8.34659C5.58659 10.3333 3.33325 12.5867 3.33325 15.3467V10.4534C3.33325 8.8667 4.30659 7.45331 5.78659 6.89331L16.3733 2.89331C18.0266 2.27997 19.7999 3.49335 19.7999 5.26668Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M30.08 18.6266V21.3734C30.08 22.1067 29.4934 22.7067 28.7467 22.7333H26.1334C24.6934 22.7333 23.3734 21.68 23.2534 20.24C23.1734 19.4 23.4934 18.6133 24.0534 18.0667C24.5467 17.56 25.2267 17.2667 25.9734 17.2667H28.7467C29.4934 17.2934 30.08 17.8933 30.08 18.6266Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 17H9.33325C8.78659 17 8.33325 16.5467 8.33325 16C8.33325 15.4533 8.78659 15 9.33325 15H18.6666C19.2133 15 19.6666 15.4533 19.6666 16C19.6666 16.5467 19.2133 17 18.6666 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWallet);
export default __webpack_public_path__ + "static/media/empty-wallet.df6acb8c49deb161d1944542071ce8f5.svg";
export { ForwardRef as ReactComponent };